import { createStore } from 'vuex'
import axios from 'axios'

export default createStore({
  state: {
    token: localStorage.getItem('token') || null,
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    isActivated: false,
    isAdmin: false,
    activationCodes: [],
    activationCodesLoading: false,
    currentAudio: {
      courseIndex: 0,
      lessonIndex: 0,
      isPlaying: false,
      progress: 0
    }
  },
  getters: {
    isAuthenticated: state => !!state.token,
    currentUser: state => state.user,
    isActivated: state => state.isActivated,
    isAdmin: state => state.isAdmin,
    activationCodes: state => state.activationCodes,
    activationCodesLoading: state => state.activationCodesLoading,
    getCurrentAudio: state => state.currentAudio
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    setUser(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
      state.isActivated = user ? user.isActivated : false
      state.isAdmin = user ? user.isAdmin : false
    },
    setActivated(state, activated) {
      state.isActivated = activated
      if (state.user) {
        state.user.isActivated = activated
        localStorage.setItem('user', JSON.stringify(state.user))
      }
    },
    setAdmin(state, isAdmin) {
      state.isAdmin = isAdmin
      if (state.user) {
        state.user.isAdmin = isAdmin
        localStorage.setItem('user', JSON.stringify(state.user))
      }
    },
    logout(state) {
      state.token = null
      state.user = null
      state.isActivated = false
      state.isAdmin = false
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    },
    setActivationCodes(state, codes) {
      state.activationCodes = codes
    },
    setActivationCodesLoading(state, loading) {
      state.activationCodesLoading = loading
    },
    setCurrentAudio(state, { courseIndex, lessonIndex }) {
      state.currentAudio.courseIndex = courseIndex
      state.currentAudio.lessonIndex = lessonIndex
    },
    setAudioProgress(state, progress) {
      state.currentAudio.progress = progress
    },
    setAudioPlaying(state, isPlaying) {
      state.currentAudio.isPlaying = isPlaying
    }
  },
  actions: {
    async register({ commit }, { username, password }) {
      try {
        console.log('发送注册请求:', { username, password: '***' });
        const response = await axios.post(`/api/register`, { username, password });
        console.log('注册响应:', response.data);
        if (response.data.token) {
          commit('setToken', response.data.token);
          commit('setUser', response.data.user);
          return true;
        }
        return false;
      } catch (error) {
        console.error('注册失败:', error);
        if (error.response) {
          console.error('错误响应数据:', error.response.data);
          console.error('错误状态码:', error.response.status);
        }
        return false;
      }
    },
    async login({ commit }, { username, password }) {
      try {
        console.log('发送登录请求:', { username, password: '***' });
        const response = await axios.post(`/api/login`, { username, password });
        console.log('登录响应:', response.data);
        if (response.data.token) {
          commit('setToken', response.data.token);
          commit('setUser', response.data.user);
          return true;
        }
        return false;
      } catch (error) {
        console.error('登录失败:', error);
        if (error.response) {
          console.error('错误响应数据:', error.response.data);
          console.error('错误状态码:', error.response.status);
        }
        return false;
      }
    },
    async checkAuth({ commit, state }) {
      if (!state.token) return false
      
      try {
        const response = await axios.get(`/api/user`, {
          headers: { 'x-auth-token': state.token }
        })
        if (response.data) {
          commit('setUser', response.data)
          commit('setActivated', response.data.isActivated)
          commit('setAdmin', response.data.isAdmin)
          return true
        }
        return false
      } catch (error) {
        console.error('验证失败:', error)
        commit('logout')
        return false
      }
    },
    async verifyActivationCode({ commit, state }, activationCode) {
      if (!state.token) return false
      
      try {
        const response = await axios.post(`/api/activate`, 
          { activationCode },
          { headers: { 'x-auth-token': state.token } }
        )
        if (response.data.activated) {
          commit('setActivated', true)
          return true
        }
        return false
      } catch (error) {
        console.error('激活失败:', error)
        return false
      }
    },
    async generateActivationCodes({ state }, count = 1) {
      if (!state.token || !state.isAdmin) return false
      
      try {
        const response = await axios.post(
          `/api/admin/activation-codes`,
          { count },
          { headers: { 'x-auth-token': state.token } }
        )
        return response.data.codes
      } catch (error) {
        console.error('生成激活码失败:', error)
        return false
      }
    },
    async getActivationCodes({ commit, state }) {
      if (!state.token || !state.isAdmin) return false
      
      commit('setActivationCodesLoading', true)
      try {
        const response = await axios.get(
          `/api/admin/activation-codes`,
          { headers: { 'x-auth-token': state.token } }
        )
        commit('setActivationCodes', response.data)
        commit('setActivationCodesLoading', false)
        return true
      } catch (error) {
        console.error('获取激活码失败:', error)
        commit('setActivationCodesLoading', false)
        return false
      }
    },
    updateCurrentAudio({ commit }, { courseIndex, lessonIndex }) {
      commit('setCurrentAudio', { courseIndex, lessonIndex })
    },
    updateAudioProgress({ commit }, progress) {
      commit('setAudioProgress', progress)
    },
    setAudioPlaying({ commit }, isPlaying) {
      commit('setAudioPlaying', isPlaying)
    }
  }
})
 
 